<template>
    <div>
        <Toolbar>
            <template>
                <BackButton :to="__('general.brands')" :href="$route('brands.index')"/>
            </template>
            <template v-slot:right>
                <ToolbarLink
                    :href="$route('brands.edit', {brandUuid: brand.uuid})">
                    <i class="fas fa-pen mr-1"/>
                    Bearbeiten
                </ToolbarLink>
                <ToolbarLink
                    :href="$route('brands.edit.distribution', {brandUuid: brand.uuid})">
                    <i class="fas fa-lock-open mr-1"/>
                    Freigaben
                </ToolbarLink>
            </template>
        </Toolbar>
        <Card>
            <div class="row">
                <div class="col-lg-4">
                    <FormGroupNew :label="__('general.name')">
                        <input type="text"
                               class="form-control"
                               :class="{'is-invalid': originalName !== currentBrand.name}"
                               name="name"
                               :placeholder="__('general.brand')"
                               v-model="currentBrand.name"
                        >
                        <span v-if="originalName === currentBrand.name" class="form-text text-muted">{{ __('general.brand_name') }}</span>
                        <span v-else
                              class="form-text text-danger">{{ __('brand.change_alert') }}</span>
                    </FormGroupNew>
                </div>
                <div class="col-12">
                    <FormGroupNew :label="__('general.logo')">
                        <div v-if="currentBrand.src === null">
                            <input type="file"
                                   class="form-control"
                                   name="logo"
                                   :placeholder="__('general.logo')"
                            >
                            <span class="form-text text-muted">{{ __('brand.logo.brand') }}</span>
                        </div>
                        <div v-else class="d-flex flex-row">
                            <div>
                                <div class="border border-form-control p-4 rounded d-inline-block">
                                    <img :src="currentBrand.src" :alt="brand.name" height="60">
                                </div>
                                <span class="form-text text-muted">{{ __('brand.logo.brand') }}</span>
                            </div>
                            <div>
                                <a :href="$route('brands.logo.delete', {brandUuid: brand.uuid})"
                                   class="btn btn-hover-danger btn-default ml-3">
                                    <i class="fas fa-trash"></i> {{ __('general.delete') }}
                                </a>
                            </div>
                        </div>
                    </FormGroupNew>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <a :href="$route('brands.index')" class="btn btn-default btn-hover-warning ml-1">
                    <i class="fas fa-times mr-1"/>{{ __('actions.abort') }}
                </a>
                <button class="btn btn-primary" @click="submit">
                    <i class="fas fa-save mr-1"/>{{ __('general.save') }}
                </button>
            </div>
        </Card>

    </div>
</template>

<script>
import CsrfToken from '@components/CsrfToken.vue'
import Toolbar from '@components/Toolbar.vue'
import BackButton from '@components/BackButton.vue'
import Card from '@components/Cards/Card.vue'
import ToolbarLink from '@components/ToolbarLink.vue'
import FormGroupNew from '@components/Form/FormGroupNew.vue'

export default {
    components: {
        FormGroupNew,
        ToolbarLink,
        Card,
        BackButton, Toolbar,
        CsrfToken,
    },

    props: {
        brand: Object,
    },

    data() {
        return {
            originalName: '',
            currentBrand: this.$inertia.form({
                name: this.brand.name,
                logo: null,
                src: this.brand.logo
            })
        }
    },

    methods: {
        submit() {
            this.currentBrand.post(this.$route('brands.update', {brandUuid: this.brand.uuid}));
        },
    },
    mounted() {
        this.originalName = this.brand.name
    },
}
</script>
